/* api/platform-notifications — CRUD for persistent notifications */
import { get, patch, del } from './client.js';

export const list      = ()    => get('/platform/notifications');
export const markRead  = (id)  => patch(`/platform/notifications/${id}/read`, {});
export const markAll   = ()    => patch('/platform/notifications/read-all', {});
export const dismiss   = (id)  => del(`/platform/notifications/${id}`);
